/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import { useState, Suspense, forwardRef, useContext, useEffect } from "react";
import {
	NexcalEmployeeLogo,
	PhcsLogo,
	QuestDiagonosticLogo,
	BrookshireLogo,
	CPLLogo,
	HealthSmartLogo,
	NexcalLogoPurple,
	ShieldPoweredLOGO,
	TestGroupLogoWithoutBackground
} from "../../../../../assets";
import CustomDataGrid from "../../../../shared/customDataGrid/CustomDataGrid";
import { AuthContext } from "../../../../../contexts";
import { maskSSN } from "../../../../../constants/maskSSN";

import { Grid, Paper } from "@mui/material";
import QRCode from "react-qr-code";
import { getLocalIPV4 } from "../../../../../utils/commonFunctions/getLocalIP4";
import encryption from "../../../../../utils/commonFunctions/encryption";
import { MEMBER_ENV } from "../../../../../config/config";

import "./healthCardPrint.css";

interface TestGroupHealthCardPrintProps {
	first_name: string;
	last_name: string;
	_ssn: string;
	group_number: number;
}

const TestGroupHealthCardPrint = forwardRef<HTMLDivElement, TestGroupHealthCardPrintProps>(
	({ first_name, last_name, _ssn, group_number }, ref) => {
		const [localIP, setLocalIP] = useState("");
		const [urlLink, setUrlLink] = useState("");
		const { member } = useContext(AuthContext);

		// console.log("Member Details55555", member);
		const ssn = maskSSN(_ssn);
		// console.log("_ssn", _ssn);

		useEffect(() => {
			// eslint-disable-next-line arrow-parens
			getLocalIPV4().then((ip) => setLocalIP(ip));
		}, []);

		useEffect(() => {
			const { group_number, date_of_birth, SSN } = member;

			if (member && localIP) {
				const localRedirectionLink = `http:${localIP}:3002/eligibility-check?gn=${group_number}&&qs=${encryption(
					SSN
				)}&&db=${encryption(date_of_birth)}`;

				const prodRedirectionLink = `www.nexcaliber.com/eligibility-check?gn=${group_number}&&qs=${encryption(
					SSN
				)}&&db=${encryption(date_of_birth)}`;

				if (member && MEMBER_ENV === "LOCAL") setUrlLink(localRedirectionLink);
				if (member && (MEMBER_ENV === "PROD" || MEMBER_ENV === "DEV")) setUrlLink(prodRedirectionLink);
			}
		}, [member, localIP]);

		return (
			<div ref={ref}>
				<div className="employee-health-card-container">
					<div className="paper-form-container">
						<Paper
							className="theme-border-radius emp-paper-container employee-print-paper-container"
							elevation={1}
						>
							<div className="employee-health-card-header">
								<span style={{ fontSize: "1rem" }}>Test Group, Inc.</span>
							</div>
							<Grid
								container
								alignItems="center"
								justifyContent="space-between"
								style={{ marginTop: "10px" }}
							>
								{/* Left logo */}
								<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="group-logo">
									<img
										src={HealthSmartLogo}
										alt="HealthSmart-logo"
										style={{ width: "7rem", height: "auto" }}
									/>
								</Grid>

								{/* Center text */}
								<Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
									<div
										className="employee-health-card-sub-header"
										style={{ textAlign: "center", paddingBottom: "20px" }}
									>
										<span style={{ marginTop: 4 }}>Administrated by Nexcaliber</span>
									</div>
								</Grid>

								{/* Right logo */}
								<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="group-logo">
									<img
										src={TestGroupLogoWithoutBackground}
										style={{
											width: "7rem",
											height: "auto"
											// marginTop: "0",
											// marginLeft: "auto"
										}}
										alt="ProgressiveLaboratories-logo"
									/>
								</Grid>
							</Grid>

							<div
								className="card-header-contact-print"
								// style={{
								// 	fontSize: ".7rem",
								// 	fontWeight: "700",
								// 	textAlign: "center",
								// 	marginBottom: ".7rem"
								// }}
							>
								Healthsmart Provider:(800) 687 0500 or www.healthsmart.com
							</div>
							<div className="employee-health-border" />
							<Grid container className="employee-card-details-container">
								<div className="employee-details-description">
									<span>Group Benifits Plan Identification Card</span>
									{/* <span>Health Plan Group #300</span> */}
								</div>
								<Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
									<div className="employee-details-container" style={{ marginTop: "0.1rem" }}>
										<span>EMPLOYEE:</span>
										<span style={{ marginLeft: "0.2rem" }}>
											{last_name.toUpperCase()}, {first_name.toUpperCase()}
										</span>
									</div>
									<div className="employee-details-container">
										<span>ID Number:</span>
										<span style={{ marginLeft: "0.2rem" }}>XXX-XX-{ssn}</span>
									</div>
									<span
										style={{
											textAlign: "left",
											marginTop: ".2rem",
											fontSize: ".5rem",
											color: "#005AA4"
										}}
									>
										Please obtain missing digits from patient
									</span>
								</Grid>
								{/* <Grid item xs={5} sm={5} md={5} lg={5} xl={5} style={{ marginTop: "-2rem" }}></Grid> */}
								<div
									className="right-details-section"
									style={{ marginTop: "-1.5rem", marginLeft: "2.5rem" }}
								>
									<span style={{ marginBottom: "1rem", fontSize: ".7rem" }}>Group Number: GP300</span>
									<div>
										<QRCode
											size={256}
											style={{
												height: "3rem",
												maxWidth: "100%",
												width: "100%",
												marginBottom: "-0.25rem"
											}}
											// value={"www.nexcaliber.com"}
											value={urlLink}
											fgColor="#4e4e4e"
											bgColor="#ffffff"
										/>
									</div>

									{/* <span style={{ marginTop: "1rem" }}>Scan to check Eligibility</span> */}
								</div>
							</Grid>
							<div className="employee-health-border" />

							<div
								className="prescription-header"
								style={{ textDecoration: "underline", textAlign: "center", fontWeight: "680" }}
							>
								Prescription Drug Benefit with Shield
							</div>

							<div className="employee-details-container-express-scripts" style={{ marginTop: "0.1rem" }}>
								<div
									className="prescription-details-container"
									style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}
								>
									<div
										className="left-side-prescription-details"
										style={{ display: "flex", flexDirection: "column", marginTop: "10px" }}
									>
										<div
											className="prescription-details"
											style={{ display: "flex", flexDirection: "row", flex: 1 }}
										>
											<span
												style={{
													marginLeft: "-.6rem",
													marginRight: "1.8rem",
													fontSize: ".7rem",
													fontWeight: "bold"
												}}
											>
												BIN: 026556
											</span>
											<span style={{ fontSize: ".7rem" }}>Shield Phone: (877) 659-6101</span>
										</div>
										<div
											className="prescription-details"
											style={{ display: "flex", flexDirection: "row", flex: 1 }}
										>
											<span
												style={{
													marginLeft: "-.6rem",
													marginRight: ".9rem",
													fontSize: ".7rem",
													fontWeight: "bold"
												}}
											>
												PCN: SHIELD
											</span>
											<span style={{ fontSize: ".7rem" }}>support@shieldpbm.com</span>
										</div>
									</div>

									<div
										className="right-side-prescription-details"
										style={{ marginTop: ".8rem", marginLeft: "0.8rem" }}
									>
										<img src={ShieldPoweredLOGO} alt="SHIELD Logo" style={{ width: "10rem" }} />
									</div>
								</div>
							</div>
						</Paper>
					</div>
				</div>
				<div className="employee-id-card-backside-container">
					<div className="paper-form-container" style={{ border: "1px solid black", borderRadius: "8px" }}>
						<div className="theme-border-radius emp-paper-container">
							<div className="card-back-topPortion-container">
								<span style={{ lineHeight: ".3rem" }}>
									<p style={{ fontWeight: 900, display: "inline-block", marginRight: "5px" }}>
										Precertification is required:
									</p>
									Call spectrum review services (800) 258-5055 for any required precertification or
									prior approval of services.
								</span>
							</div>

							<div className="footer-border" />

							<div className="card-back-midPortion-container">
								<div className="upper-section">
									<span>For Online Claim access visit the Health Plan Portal</span>
									<br></br>
									<span>Website address is https://member.enrollment.nexcaliber.com</span>
								</div>
								<div className="footer-border" />

								<div className="footer-top-content-container" style={{ padding: "0.2rem" }}>
									<span
										className="footer-top-sub-content"
										style={{ marginLeft: "4px", fontSize: "0.65rem" }}
									>
										Employees: To discuss benefits and/or status of a claim call (972) 248-1011 Or
										(800) 741-0185 Mon-Fri 8:30am-5:00pm CST
									</span>
								</div>
							</div>

							<div className="footer-border" />

							<div className="summary-benefits-footer-container">
								<div className="footer-bottom-content" style={{ marginTop: "0.2rem" }}>
									Mail all claims to: NEXCALIBER , PO BOX 802422, DALLAS, TX 75380
								</div>
								<div className="footer-logo-container">
									<img src={NexcalEmployeeLogo} alt="Nexcal employee Logo" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
);

export default TestGroupHealthCardPrint;
